module.exports = __webpack_public_path__ + "poster7.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster7.png
// module id = 1137
// module chunks = 10